import * as React from "react";
import { ToggleSwitch, TitleBar, Accordion, modules, Module, isModuleActive, getModuleLabel } from "modules/common";
import { useContext } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    activatedModules: string[];
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    roleType?: number;
}

export const ModuleManagement: React.FC<Props> = ({ activatedModules, onChange, roleType }) => {
    const { fontSize, lowVision } = useContext(AccessibilityContext);
    if (!activatedModules) {
        return null;
    }

    const isModuleAccessible = (module: Module) =>
        !module.carouselOnly && module.roles.includes(roleType ?? 0);

    const renderModulesRow = (item: Module) =>
        isModuleAccessible(item) && (
            <div key={item.id} className="module-management-row">
                <div>
                    <label htmlFor={`${item.id}`} className="module-management-row__label">
                        {getModuleLabel(item.id, roleType)}
                    </label>
                </div>
                <ToggleSwitch
                    htmlFor={`${item.id}`}
                    value={`${item.id}`}
                    onChange={onChange}
                    checked={isModuleActive(activatedModules, item.id)}
                    className="module-management-row__toggle"
                />
            </div>
        );

    const renderGroupContent = (section: Module) => (
        <div className="module-management" key={section.id}>
            {section.children?.filter(isModuleAccessible).map(renderModulesRow)}
        </div>
    );

    const renderGroup = (section: Module, isLast: boolean) => (
        <div key={section.id}>
            <Accordion
                title={getModuleLabel(section.id, roleType)}
                className="module-management-accordion"
                isButtonWithBorder
            >
                {renderGroupContent(section)}
            </Accordion>
            {!isLast ? <div className="thin-separator" /> : <div className="thin-spacer"></div>}
        </div>
    );

    return (
        <div>
            <TitleBar>
                <TitleBar.Left>
                    <span
                        className="title-bar-text profile-title"
                        style={{ fontSize: `${fontSize}%` }}
                    >
                        Moduli
                    </span>
                </TitleBar.Left>
            </TitleBar>
            <span className="module-management__description">
                Upravljajte aktivacijom i deaktivacijom modula ovisno o vašim interesima.
            </span>
            <div className="module-management">
                {modules(lowVision ?? false)
                    .filter(isModuleAccessible)
                    .map((module, index, filteredModules) =>
                        module.children
                            ? renderGroup(module, index === filteredModules.length - 1)
                            : renderModulesRow(module)
                    )}
            </div>
        </div>
    );
};
